//项目类型
export const PROJECT_CATEGORY = {
  QUESTIONNAIRE_SURVEY: 0, //问卷调查
  SPOT_INVESTIGATIONS: 1, //明察暗访
  MANUAL_IMPORT: 2 //人工导入
}

//结算方式
export const SETTLE_MODE = {
  ANSWER_NUMBER: 1, //按答卷数量
  DAY: 2, //按天
  LADDER_PRICING: 3, //按阶梯计价
  POINT_POSITION: 4 //按点位
}

//任务状态
export const TASK_STATUS = {
  NOT_SUBMITTED: 0, //待提交
  CONFIRMING: 1, //确认中
  CONFIRMED: 2, //已确认
  REFUSED: 3, //不认可待提交
  REVOCATION: 4, //撤销待提交
  CONFIRM_PAID: 5 //已确认打款
}

//审批状态
export const AUDIT_STATUS = {
  WAIT: 0, //不可发起审批
  READY: 1, //待发起
  AUDITING: 2, //待审批
  PASS: 3, //已通过
  REJECT: 4, //已驳回
  PAYING: 5, //待支付
  PAID: 6, //已支付
  CANCEL: 7, //已撤销
  CONFIRMPAID: 8 // 已确认打款
}

export const SETTLE_STAGE = {
  RELATE_STATEMENT: 1, // '关联调查数据'
  SUBMIT_STATEMENT: 2, // '提交结算单'
  APPROVER_CONFIRM: 3, // '调查员确认'
  COST_AUDIT: 4, // '费用审批'
  COST_OFFER: 5 // '费用发放'
}

//结算对象类型
export const SETTLE_OBJ_TYPE = {
  INVESTIGATOR: 0, // 调查员
  PROXY: 1 // 代理
}

//费用发放的支付状态
export const PAY_STATUS = {
  // 0-支付中， 1-成功， 2-失败， 3-所有， -1-未发起支付
  PAYING: 0,
  PAY_SUCCESS: 1,
  PAY_FAILURE: 2,
  PAY_All: 3,
  NOT_PAY: -1
}


//评论状态
export const COMMENT_STATUS = {
  // 0-待我评价，1-我已评价，2-调查员给我的评价（全部），3-调查员给我的评价（待评价），4-调查员给我的评价（已评价）
  UNEVALUATED: 0,
  EVALUATED: 1,
  ALL_EVALUATED: 2,
  NOT_EVALUATED: 3,
  BE_EVALUATED: 4,
}

//是否已读
export const VIEW_STATUS = {
  NOT_VIEWED: 0, //未读
  VIEWED: 1 //已读
}